module.exports = __webpack_public_path__ + "img/errorpageIcon.f50eeae4.svg";